export enum LegacyClientPanelUrl {
  PANEL = "/panel",
}
